<template>
  <div>
    <search-area tabName="首页配置" @search="search" @add="add">
      <Form
        ref="searchParam"
        :model="searchParam"
        :label-width="55"
        inline
        label-position="right"
        label-colon
      >
        <FormItem label="是否上架" prop="name" :label-width="105">
          <Select
            v-model="searchParam.isPublic"
            style="width: 160px"
            @on-change="search(false, false)"
          >
            <Option value="">全部</Option>
            <Option value="1">已上架</Option>
            <Option value="0">已下架</Option>
          </Select>
        </FormItem>
      </Form>
    </search-area>
    <table-area
      :columns="columns"
      :data="bannerList"
      :total="total"
      @search="search"
      :pageNum="searchParam.pageNum"
      :pageSize="searchParam.pageSize"
    ></table-area>
    <el-dialog title="新增banner" :visible.sync="showDispatch">
      <el-form :model="addInfo" label-width="120px">
        <el-form-item label="类型" prop="type">
          <el-select
            v-model="addInfo.type"
            @change="handleTypeChange"
            placeholder="请选择类型"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="banner图" prop="banner">
          <el-upload
            class="form-upload"
            ref="uploadcover"
            action="#"
            name="coverUrl"
            :accept="
              addInfo.type == 5
                ? '.png,.jpg,.gif,.GIF,.mp4,.MP4,.mov,.MOV'
                : addInfo.type == 1 || addInfo.type == 2 || addInfo.type == 4
                ? '.png,.jpg'
                : '.mp4,.MP4,.mov,.MOV'
            "
            :show-file-list="false"
            :auto-upload="false"
            :on-change="handManyFile"
          >
            <el-button slot="trigger" size="small" type="primary"
              >上传图片/视频
            </el-button>
          </el-upload>
          <span
            v-if="addInfo.cover"
            style="
              display: inline-block;
              width: 100px;
              height: 100px;
              position: relative;
            "
          >
            <img
              @click="deleteImg"
              src="@/assets/delete.png"
              style="height: 20px; width: 20px; position: absolute; right: 0"
            />
            <el-popover
              placement="left"
              title=""
              trigger="hover"
              width="200"
              v-if="!isVideoFile(addInfo.cover)"
            >
              <img :src="host + addInfo.cover" width="100%" />
              <img
                slot="reference"
                :src="host + addInfo.cover"
                :alt="host + addInfo.cover"
                style="height: 80px; width: 80px; padding: 10px"
              />
            </el-popover>
            <video
              :src="host + addInfo.cover"
              v-if="isVideoFile(addInfo.cover)"
              style="width: 100px"
              controls
            ></video>
          </span>
        </el-form-item>
        <el-form-item
          label="跳转链接"
          v-if="
            addInfo.type == 1 ||
            addInfo.type == 2 ||
            addInfo.type == 4 ||
            addInfo.type == 5
          "
        >
          <el-input v-model="addInfo.url" placeholder="跳转链接"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showDispatch = false">取 消</el-button>
        <el-button type="primary" @click="onConfirm">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 视频播放弹窗 -->
    <el-dialog title="视频播放" :visible.sync="showVideoModal" width="60%">
      <video
        v-if="showVideoModal"
        :src="videoModalUrl"
        controls
        autoplay
        style="width: 100%; max-height: 70vh"
      ></video>
    </el-dialog>
  </div>
</template>
<script>
import columns from "./home-column";
export default {
  data() {
    return {
      columns: columns(this),
      // 列表数据总数
      total: 1,
      // 加载中
      loading: false,
      // 搜索参数
      searchParam: {
        currentPage: 1,
        pageSize: 10,
        isPublic: null,
      },
      bannerList: [],
      options: [
        { value: 1, label: "banner" },
        { value: 2, label: "优惠券弹窗" },
        { value: 4, label: "招募弹窗" },
        { value: 3, label: "视频" },
        { value: 5, label: "金刚区" },
      ],
      addInfo: {
        cover: "",
        url: "", // 跳转链接 pages/home/product-detail/product-detail?id=${productId}
        type: 1,
        isPublic: 1, // 0-不公开 1-公开
      },
      showDispatch: false,
      showVideoModal: false,
      videoModalUrl: "",
    };
  },
  computed: {},
  created() {
    this.getBannerList();
  },
  methods: {
    // 检测文件是否为视频
    isVideoFile(filePath) {
      if (!filePath) return false;
      const videoExtensions = ['.mp4', '.MP4', '.mov', '.MOV'];
      return videoExtensions.some(ext => filePath.toLowerCase().endsWith(ext.toLowerCase()));
    },
    handleTypeChange(val) {
      let urlList = [
        "/pages/home/coupon-list/coupon-list",
        "/pages/home/coupon-list/coupon-list",
        "",
        "/pages/home/partner-info/partner-info",
      ];
      this.addInfo.url = urlList[val - 1];
    },
    search() {
      this.searchParam.currentPage = 1;
      this.getBannerList();
    },
    async getBannerList() {
      let { list, total } = await this.$post(
        "/banner/listByPage",
        this.searchParam
      );
      this.bannerList = list;
      this.total = total;
    },
    add() {
      this.addInfo = {
        cover: "",
        url: "",
        type: 1,
        isPublic: 1, // 0-不公开 1-公开
      };
      this.showDispatch = true;
    },
    // 上传商品封面
    async handManyFile(file, fileList, type) {
      var param = new FormData();
      param.append("file", file.raw);
      let data = await this.$upload("/File/upload", param);
      // 商品封面图
      this.addInfo.cover = data;
    },
    deleteImg(type, index) {
      this.$confirm("确认删除该图片, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 删除封面
          this.addInfo.cover = "";
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 确认新增/编辑banner信息
    async onConfirm() {
      // 新增
      let data = await this.$post("/banner/enter", this.addInfo);
      this.$message({ type: "info", message: "保存成功" });
      this.showDispatch = false;
      this.getBannerList();
    },
  },
  components: {},
};
</script>

<style lang="stylus" scoped></style>
